<template>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 relative">
        <div class="relative">
            <label>TC Kimlik</label>
            <input type="text" v-model="localForm.driver_tcno" @input="handleInput" @focus="showTc = true"
                @blur="hideTcResults" @keydown.down.prevent="moveTcFocus(1)" @keydown.up.prevent="moveTcFocus(-1)"
                @keydown.enter.prevent="selectTc" @keydown.tab.prevent="onTabTc($event)"
                class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
            <ul v-if="showTc && tcResults.length"
                class="absolute z-10  bg-white dark:bg-gray-800 text-black dark:text-white border mt-1 rounded w-full shadow">
                <li v-for="(driver, index) in tcResults" :key="driver.driver_tcno" @click="selectDriver(driver)"
                    :class="['px-4 py-2 cursor-pointer', tcFocusedIndex === index ? 'bg-indigo-100' : 'hover:bg-gray-100 hover:dark:bg-gray-900']">
                    {{ driver.driver_tcno }}
                </li>
            </ul>
        </div>
        <div>
            <label>Ad Soyad</label>
            <input type="text" v-model="localForm.driver_name" :disabled="localForm.driver_id !== null"
                @input="handleInput"
                class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
        </div>
        <div class="relative">
            <label>Ehliyet No</label>
            <input type="text" v-model="localForm.driver_licenceno" @input="handleInput" @focus="showLicense = true"
                @blur="hideLicenseResults" @keydown.down.prevent="moveLicenseFocus(1)"
                @keydown.up.prevent="moveLicenseFocus(-1)" @keydown.enter.prevent="selectLicense" @keydown.tab.prevent="onTabLicense($event)"
                class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
            <ul v-if="showLicense && licenseResults.length"
                class="absolute z-10 bg-white dark:bg-gray-800 text-black dark:text-white border mt-1 rounded w-full shadow">
                <li v-for="(driver, index) in licenseResults" :key="driver.driver_licenceno"
                    @click="selectDriver(driver)"
                    :class="['px-4 py-2 cursor-pointer', licenseFocusedIndex === index ? 'bg-indigo-100' : 'hover:bg-gray-100 hover:dark:bg-gray-900']">
                    {{ driver.driver_licenceno }}
                </li>
            </ul>
        </div>
        <div>
            <label>Telefon</label>
            <input type="tel" v-model="localForm.driver_telno" :disabled="localForm.driver_id !== null"
                @input="handleInput"
                class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
        </div>
        <div>
            <label>Şehir</label>
            <input type="text" v-model="localForm.driver_province" :disabled="localForm.driver_id !== null"
                @input="handleInput"
                class="w-full border rounded px-4 py-2 bg-primary-bg dark:bg-primary-dark-bg dark:border-dark-border focus:outline-none focus:ring focus:ring-indigo-300" />
        </div>
        <div class="col-span-full flex justify-end gap-2 mt-4">
            <button v-if="!localForm.driver_id" @click="onCreate"
                class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded">Ekle</button>
            <button @click="emitReset" class="bg-gray-400 text-white px-4 py-2 rounded">Temizle</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "DriverForm",
    props: {
        form: { type: Object, required: true },
        drivers: { type: Array, default: () => [] },
    },
    emits: ['update:form', 'reset', 'create', 'search', 'search-tc'],
    data() {
        return {
            localForm: { ...this.form },
            showTc: false,
            showLicense: false,
            tcFocusedIndex: -1,
            licenseFocusedIndex: -1,
            tcDebounce: null,
            licenseDebounce: null
        };
    },
    watch: {
        form: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.localForm = { ...newVal };
            }
        },
        'localForm.driver_tcno'(val) {
            clearTimeout(this.tcDebounce);
            if (val && val.length >= 1) {
                this.tcDebounce = setTimeout(() => {
                    this.$emit('search-tc', val);
                }, 200);
            }
        },
        'localForm.driver_licenceno'(val) {
            clearTimeout(this.licenseDebounce);
            if (val && val.length >= 1) {
                this.licenseDebounce = setTimeout(() => {
                    this.$emit('search', val);
                }, 200);
            }
        },

    },
    computed: {
        tcResults() {
            return this.localForm.driver_tcno.length < 1
                ? []
                : this.drivers.filter(d => d.driver_tcno.includes(this.localForm.driver_tcno));
        },
        licenseResults() {
            return this.localForm.driver_licenceno.length < 1
                ? []
                : this.drivers.filter(d =>
                    d.driver_licenceno.toLowerCase().includes(this.localForm.driver_licenceno.toLowerCase()));
        }
    },
    methods: {
        handleInput() {
            const tcno = this.localForm.driver_tcno?.trim() || '';
            const licenceno = this.localForm.driver_licenceno?.trim() || '';

            if ((!tcno || !licenceno) && this.localForm.driver_id) {
                this.localForm.driver_name = '';
                this.localForm.driver_tcno = '';
                this.localForm.driver_licenceno = '';
                this.localForm.driver_telno = '';
                this.localForm.driver_province = '';
                this.localForm.driver_id = null;
            }

            this.$emit('update:form', { ...this.localForm });
        },

        focusNextInput(currentTarget) {
            const focusable = this.$el.querySelectorAll('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
            const elements = Array.from(focusable).filter(el => !el.disabled && el.getAttribute('tabindex') !== '-1');
            const index = elements.indexOf(currentTarget);
            if (index >= 0) {
                const next = elements[index + 1];
                if (next && typeof next.focus === 'function') {
                    next.focus();
                }
            }
        },

        selectDriver(driver) {
            this.localForm = { ...driver };
            this.$emit('update:form', { ...driver });
            this.showTc = false;
            this.showLicense = false;
        },
        onTabTc(evt) {
            const results = this.tcResults;
            if (!results || results.length === 0) {
                this.focusNextInput(evt.target);
                return;
            }
            if (results.length === 1) {
                this.selectDriver(results[0]);
                this.$nextTick(() => this.focusNextInput(evt.target));
                return;
            }
            // Multiple results: cycle and preview value without closing list
            this.moveTcFocus(1);
            const highlighted = results[this.tcFocusedIndex];
            if (highlighted) {
                this.localForm.driver_tcno = highlighted.driver_tcno;
                this.$emit('update:form', { ...this.localForm });
                this.showTc = true;
            }
        },
        onTabLicense(evt) {
            const results = this.licenseResults;
            if (!results || results.length === 0) {
                this.focusNextInput(evt.target);
                return;
            }
            if (results.length === 1) {
                this.selectDriver(results[0]);
                this.$nextTick(() => this.focusNextInput(evt.target));
                return;
            }
            // Multiple results: cycle and preview value without closing list
            this.moveLicenseFocus(1);
            const highlighted = results[this.licenseFocusedIndex];
            if (highlighted) {
                this.localForm.driver_licenceno = highlighted.driver_licenceno;
                this.$emit('update:form', { ...this.localForm });
                this.showLicense = true;
            }
        },
        hideTcResults() {
            setTimeout(() => (this.showTc = false), 200);
        },
        hideLicenseResults() {
            setTimeout(() => (this.showLicense = false), 200);
        },
        moveTcFocus(dir) {
            this.tcFocusedIndex = (this.tcFocusedIndex + dir + this.tcResults.length) % this.tcResults.length;
        },
        moveLicenseFocus(dir) {
            this.licenseFocusedIndex = (this.licenseFocusedIndex + dir + this.licenseResults.length) % this.licenseResults.length;
        },
        selectTc() {
            if (this.tcFocusedIndex >= 0) {
                this.selectDriver(this.tcResults[this.tcFocusedIndex]);
            } else if (this.tcResults.length === 1) {
                this.selectDriver(this.tcResults[0]);
            }
        },
        selectLicense() {
            if (this.licenseFocusedIndex >= 0) {
                this.selectDriver(this.licenseResults[this.licenseFocusedIndex]);
            } else if (this.licenseResults.length === 1) {
                this.selectDriver(this.licenseResults[0]);
            }
        },
        onCreate() {
            if (
                !this.localForm.driver_tcno ||
                !this.localForm.driver_name ||
                !this.localForm.driver_licenceno ||
                !this.localForm.driver_telno ||
                !this.localForm.driver_province
            ) {
                this.$toast?.error?.("Lütfen tüm alanları doldurun!");
                return;
            }

            this.$emit('create', { ...this.localForm });
        },

        emitReset() {
            this.$emit('reset');
        }
    }
};
</script>